export const SET_TIME = [2, 5, 10, 15, 20];
export const SET_QUANTITY = [1, 2, 3, 4, 5];
export const PROMPTS_PER_SET = [4, 8, 12, 16, 20];

export const WARM_UP_SESSION = {
  setTime: 5,
  setQuantity: 1,
  promptsPerSet: 8,
  subjects: [],
  stretches: true,
  graduallyMoreTime: false,
};

export const FULL_SESSION = {
  setTime: 5,
  setQuantity: 3,
  promptsPerSet: 8,
  subjects: [],
  stretches: true,
  graduallyMoreTime: false,
};
